<template>
  <div class="row">
    <div class="col-md-12">
      <location-groups-form @on-submit="onSubmit"></location-groups-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import LocationGroupsForm from './LocationGroupsForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      LocationGroupsForm
    },
    data () {
      return {
        LocationGroupsModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onSubmit (model, isValid) {
        this.LocationGroupsModel = model
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/LocationGroups/LocationGroupsAdd.vue